/**
 * Runtime configuration.
 *
 * Values are resolved in this order:
 *   1. window.__RUNTIME_CONFIG__  – injected by Kubernetes ConfigMap at deploy time
 *   2. process.env                – baked in by react-scripts at build time (used during local dev)
 */

interface RuntimeConfig {
  REACT_APP_API?: string;
  REACT_APP_WS?: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

export const config = {
  API_URL: window.__RUNTIME_CONFIG__?.REACT_APP_API || process.env.REACT_APP_API,
  SOCKET_URL: window.__RUNTIME_CONFIG__?.REACT_APP_WS || process.env.REACT_APP_WS,
};
